import { lazy } from "react"
import {useRoutes, Navigate} from 'react-router-dom'

const Login = lazy(() => import("../views/Login"))
const Dashboard = lazy(() => import("../views/Dashboard"))
const Invoice = lazy(() => import("../views/invoice/Index"))
const Report = lazy(() => import("../views/invoice/Report"))
const User = lazy(() => import("../views/master/User"))
const Profile = lazy(() => import("../views/master/Profile"))
const Role = lazy(() => import("../views/master/Role"))
const Permission = lazy(() => import("../views/master/Permission"))
const Configuration = lazy(() => import("../views/master/Configuration"))
const MenuLayout = lazy(() => import("../component/MenuLayout"))

export default function Routes() {
  const getHomeRoute = () => {
    const isLogged = sessionStorage.getItem('inv_isLogged')
    if (isLogged) {
      return '/dashboard'
    } else {
      //window.document.body.style.height="min-height: 512.781px;"
      //window.document.body.classList.add('login-page')
      return '/login'
    }
  }

  return  useRoutes([
    {
      path: '/',
      index: true,
      element: <Navigate replace to={getHomeRoute()} />
    },
    {
      path: '/login',
      element: <Login/>,
    },
    {
      path: '/logout',
      element: <MenuLayout/>,
    },
    
    {
      path: '/dashboard',
      element: <MenuLayout/>,
      children: [{path:'/dashboard', element:<Dashboard/>}]
    },
    {
      path: '/invoice',
      element: <MenuLayout/>,
      children:[{path:'/invoice', element:<Invoice />}]
    },
    {
      path: '/report',
      element: <MenuLayout/>,
      children:[{path:'/report', element:<Report />}]
    },
    {
      path: '/user',
      element: <MenuLayout/>,
      children:[{path:'/user', element:<User />}]
    },
    {
      path: '/profile',
      element: <MenuLayout/>,
      children:[{path:'/profile', element:<Profile />}]
    },
    {
      path: '/role',
      element: <MenuLayout/>,
      children:[{path:'/role', element:<Role />}]
    },
    {
      path: '/permission',
      element: <MenuLayout/>,
      children:[{path:'/permission', element:<Permission />}]
    },
    {
      path: '/configuration',
      element: <MenuLayout/>,
      children:[{path:'/configuration', element:<Configuration />}]
    }
    
    
  ])
}
